let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1E6UJ")).then(() => parcelRequire('5ytLq'));